export default __webpack_public_path__ + "static/media/blog14.f5fcf5ec.jpg";